import {
  useGateValue as realUseGateValue,
  useExperiment as realUseExperiment,
} from "@statsig/react-bindings";

const useStatsig = () => {

  const useGateValue = (gateName: string) => realUseGateValue(gateName);

  const useExperimentValue = <T>(experimentName: string, paramName: string, defaultValue: T): T => {
    const exp = realUseExperiment(experimentName);
    const get = exp.get<T>(paramName, defaultValue);
    return get as T;
  };

  // This allows lazy evaluation.
  const useExperiment = <T>(experimentName: string) => realUseExperiment(experimentName);

  return {
    getGate: useGateValue,
    getExperiment: useExperiment,
    getExperimentValue: useExperimentValue,
  };
};

export default useStatsig;

